<template>
<body class="app sidebar-mini ltr light-mode">
<!--     <div id="global-loader">-->
<!--        <img src="/images/loader.svg" class="loader-img" alt="Loader">-->
<!--    </div>-->
    <!-- PAGE -->
    <div class="page">
        <div class="page-main">

            <!-- app-Header -->
            <div class="app-header header sticky">
                <div class="container-fluid main-container">
                    <div class="d-flex">
                        <a aria-label="Hide Sidebar" class="app-sidebar__toggle" data-bs-toggle="sidebar" href="javascript:void(0)"></a>
                        <!-- sidebar-toggle-->
                        <router-link :to="{ name: 'dashboard' }"><a class="logo-horizontal " href="javascript:void(0)">
                            <img src="/img/logo.png" class="header-brand-img desktop-logo" alt="logo">
                            <img src="/img/logo.png" class="header-brand-img light-logo1" alt="logo" height="40">
                        </a></router-link>
                        <!-- LOGO -->
                        <!-- <div class="main-header-center ms-3 d-none d-lg-block">
                            <input type="text" class="form-control" id="typehead" placeholder="Search for results...">
                            <button class="btn px-0 pt-2"><i class="fe fe-search" aria-hidden="true"></i></button>
                        </div> -->
                        <div class="d-flex order-lg-2 ms-auto header-right-icons">
                            <!-- SEARCH -->
                            <button class="navbar-toggler navresponsive-toggler d-lg-none ms-auto" type="button"
                                data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent-4"
                                aria-controls="navbarSupportedContent-4" aria-expanded="false"
                                aria-label="Toggle navigation">
                                <span class="navbar-toggler-icon fe fe-more-vertical"></span>
                            </button>
                            <div class="navbar navbar-collapse responsive-navbar p-0">
                                <div class="collapse navbar-collapse" id="navbarSupportedContent-4">
                                    <div class="d-flex order-lg-2">
                                        <div class="dropdown d-lg-none d-flex">
                                            <a href="javascript:void(0)" class="nav-link icon" data-bs-toggle="dropdown">
                                                <i class="fe fe-search"></i>
                                            </a>
                                            <div class="dropdown-menu header-search dropdown-menu-start">
                                                <div class="input-group w-100 p-2">
                                                    <input type="text" class="form-control" placeholder="Search....">
                                                    <div class="input-group-text btn btn-primary">
                                                        <i class="fa fa-search" aria-hidden="true"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                      <div class="d-flex country">
                                        <a class="nav-link icon text-center" data-bs-target="#country-selector"
                                           data-bs-toggle="modal">
                                          <i class="fe fe-globe"></i><span
                                            class="fs-16 ms-2 d-none d-xl-block">{{ currentLanguageName }}</span>
                                        </a>
                                      </div>
                                        
                                        <!-- COUNTRY -->
                                        <div class="d-flex">
                                            <a class="nav-link icon theme-layout nav-link-bg layout-setting">
                                                <span class="dark-layout"><i class="fe fe-moon"></i></span>
                                                <span class="light-layout"><i class="fe fe-sun"></i></span>
                                            </a>
                                        </div>
                                        <!-- CART -->
                                        <div class="dropdown d-flex">
                                            <a class="nav-link icon full-screen-link nav-link-bg">
                                                <i class="fe fe-minimize fullscreen-button"></i>
                                            </a>
                                        </div>
                                      <!-- CART -->
                                      <!-- Theme-Layout -->
<!--                                      <div class="dropdown  d-flex shopping-cart">-->
<!--                                        <a class="nav-link icon text-center" data-bs-toggle="dropdown">-->
<!--                                          <i class="fe fe-shopping-cart"></i><span class="badge bg-secondary header-badge">{{ cartTotalItems }}</span>-->
<!--                                        </a>-->
<!--                                        <div class="dropdown-menu dropdown-menu-end dropdown-menu-arrow">-->
<!--                                          <div class="drop-heading border-bottom">-->
<!--                                            <div class="d-flex">-->
<!--                                              <h6 class="mt-1 mb-0 fs-16 fw-semibold text-dark"> My Shopping Cart</h6>-->
<!--                                              <div class="ms-auto">-->
<!--                                                <span class="badge bg-danger-transparent header-badge text-danger fs-14">Hurry Up!</span>-->
<!--                                              </div>-->
<!--                                            </div>-->
<!--                                          </div>-->
<!--                                          <div class="header-dropdown-list message-menu scrollable-cart">-->
<!--                                            <template v-if="!isCartEmpty">-->
<!--                                              <div-->
<!--                                                  class="dropdown-item d-flex p-4"-->
<!--                                                  v-for="item in cartItems"-->
<!--                                                  :key="item.id"-->
<!--                                              >-->
<!--      <span-->
<!--          class="avatar avatar-xl br-5 me-3 align-self-center cover-image"-->
<!--          :style="{ backgroundImage: `url(${item.imageUrl || 'default.jpg'})` }"-->
<!--      ></span>-->
<!--                                                <div class="wd-50p">-->
<!--                                                  <h5 class="mb-1">{{ item.name }}</h5>-->
<!--                                                  <span>Status: <span class="text-success">In Stock</span></span>-->
<!--                                                  <p class="fs-13 text-muted mb-0">Quantity: {{ item.quantity }}</p>-->
<!--                                                </div>-->
<!--                                                <div class="ms-auto text-end d-flex fs-16">-->
<!--        <span class="fs-16 text-dark d-none d-sm-block px-4">-->
<!--          ${{ item.referencePrice * item.quantity }}-->
<!--        </span>-->
<!--                                                  <a href="javascript:void(0)" class="fs-16 btn p-0 cart-trash" @click.prevent="removeItem(item.id)">-->
<!--                                                    <i class="fe fe-trash-2 border text-danger brround d-block p-2"></i>-->
<!--                                                  </a>-->
<!--                                                </div>-->
<!--                                              </div>-->
<!--                                            </template>-->

<!--                                            <template v-else>-->
<!--                                              <div class="text-center p-4 text-muted">Votre panier est vide.</div>-->
<!--                                            </template>-->
<!--                                          </div>-->

<!--                                          <div class="dropdown-divider m-0"></div>-->
<!--                                          <div class="dropdown-footer" v-if="!isCartEmpty">-->
<!--                                            <router-link-->
<!--                                                :to="{ name: 'shopCart' }"-->
<!--                                                class="btn btn-primary btn-pill w-sm btn-sm py-2"-->
<!--                                            >-->
<!--                                              <i class="fe fe-check-circle"></i> Checkout-->
<!--                                            </router-link>-->
<!--                                            <span class="float-end p-2 fs-17 fw-semibold">Total: ${{ cartTotal }}</span>-->
<!--                                          </div>-->
<!--                                        </div>-->
<!--                                      </div>-->
                                        <!-- FULL-SCREEN -->
                                        <div class="dropdown  d-flex notifications">
                                          <a class="nav-link icon" data-bs-toggle="dropdown">
                                            <i class="fe fe-bell"></i>
                                            <span v-if="notificationCount > 0" class="pulse"></span>
                                          </a>
                                            <div class="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                                                <div class="drop-heading border-bottom">
                                                    <div class="d-flex">
                                                        <h6 class="mt-1 mb-0 fs-16 fw-semibold text-dark">Notifications
                                                        </h6>
                                                    </div>
                                                </div>
                                                <div class="notifications-menu scrollable-cart">
                                                  <a
                                                      v-for="notif in allNotifications.filter(n => !n.read)"
                                                  :key="notif.id"
                                                  class="dropdown-item d-flex"
                                                  href="#"
                                                  >
                                                  <div
                                                      class="me-3 notifyimg brround"
                                                      :class="{
      'bg-primary': notif.type === 'SALE_CONFIRMATION',
      'bg-success': notif.type === 'PAYMENT_CONFIRMATION',
      'bg-warning': notif.type === 'PURCHASE_CONFIRMATION',
      'bg-info': notif.type === 'DELIVERY_CONFIRMATION'
    }"
                                                  >
                                                    <i
                                                        :class="{
        'fe fe-shopping-cart': notif.type === 'SALE_CONFIRMATION',
        'fe fe-dollar-sign': notif.type === 'PAYMENT_CONFIRMATION',
        'fe fe-package': notif.type === 'PURCHASE_CONFIRMATION',
        'fe fe-truck': notif.type === 'DELIVERY_CONFIRMATION'
      }"
                                                    ></i>
                                                  </div>

                                                  <div class="mt-1 wd-80p">
                                                    <h5 class="notification-label mb-1">
                                                      {{ getNotificationTitle(notif) }}
                                                    </h5>
                                                    <span class="notification-subtext">{{ formatDate(notif.notificationDate) }}</span>
                                                    <button class="btn btn-sm btn-link text-primary" @click.prevent="markAsRead(notif.id)">
                                                      Marquer comme lu
                                                    </button>
                                                  </div>
                                                  </a>

                                                </div>
                                                <div class="dropdown-divider m-0"></div>
                                                <a href="#"
                                                    class="dropdown-item text-center p-3 text-muted">View all
                                                    Notification</a>
                                            </div>
                                        </div>
                                        <!-- NOTIFICATIONS -->
                                        <!-- SIDE-MENU -->
                                        <div class="dropdown d-flex profile-1">
                                            <a href="javascript:void(0)" data-bs-toggle="dropdown" class="nav-link leading-none d-flex">
                                                <img src="/images/users/21.jpg" alt="profile-user"
                                                    class="avatar  profile-user brround cover-image">
                                            </a>
                                            <div class="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                                                <div class="drop-heading">
                                                  <div class="text-center">
                                                    <h5 class="text-dark mb-0 fs-14 fw-semibold">{{ user?.username }}</h5>
                                                    <h5 class="text-dark mb-0 fs-14 fw-semibold">{{ user?.email }}</h5>
                                                    <small class="text-muted">{{ user?.clientRoles[0] }}</small>
                                                  </div>
                                                </div>
                                                <div class="dropdown-divider m-0"></div>
                                                <a class="dropdown-item" href="#">
                                                    <i class="dropdown-icon fe fe-user"></i> Profil
                                                </a>
                                                <a class="dropdown-item" href="#" @click.prevent="logout" title="Déconnexion">
                                                    <i class="dropdown-icon fe fe-alert-circle"></i> Déconnexion
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /app-Header -->

            <!--APP-SIDEBAR-->
            <div class="sticky">
                <div class="app-sidebar__overlay" data-bs-toggle="sidebar"></div>
                <div class="app-sidebar">
                    <div class="side-header">
                        <router-link :to="{ name: 'dashboard'}"><a class="header-brand1" href="#">
                            <img src="/img/logo.png" class="header-brand-img desktop-logo" alt="logo">
                            <img src="/img/logo.png" class="header-brand-img toggle-logo" alt="logo">

                            <img src="/img/logo.png" class="header-brand-img light-logo" alt="logo">
                            <img src="/img/logo.png" class="header-brand-img light-logo1" alt="logo">
                            <!-- <img src="/images/brand/icon-white.png" class="header-brand-img light-logo" alt="logo">
                            <img src="/images/brand/logo-white.png" class="header-brand-img light-logo1" alt="logo"> -->
                        </a></router-link>
                        <!-- LOGO -->
                    </div>
                    <div class="main-sidemenu">
                        <div class="slide-left disabled" id="slide-left">
                            <svg xmlns="http://www.w3.org/2000/svg"
                                fill="#7b8191" width="24" height="24" viewBox="0 0 24 24">
                                <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z" />
                            </svg>
                        </div>
                      <ul class="side-menu">
                        <li class="sub-category">
                          <h3>Menu</h3>
                        </li>

                        <li
                            class="slide"
                            v-for="item in filteredMenu"
                            :key="item.label"
                        >
                          <!-- Lien direct sans sous-menu -->
                          <template v-if="!item.children || item.children.length === 0">
                            <router-link
                                :to="{ name: item.route, params: item.routeParams || {} }"
                                class="side-menu__item fw-semibold"
                                style="color: #000;"
                            >
                              <i :class="'side-menu__icon ' + item.icon"></i>
                              <span class="side-menu__label text-uppercase">{{ item.label }}</span>
                            </router-link>
                          </template>

                          <!-- Sous-menu -->
                          <template v-else>
                            <a
                                href="javascript:void(0)"
                                class="side-menu__item fw-semibold"
                                data-bs-toggle="slide"
                                style="color: #000;"
                            >
                              <i :class="'side-menu__icon ' + item.icon"></i>
                              <span class="side-menu__label text-uppercase">{{ item.label }}</span>
                              <i class="angle fe fe-chevron-right"></i>
                            </a>

                            <ul class="slide-menu">
                              <li class="panel sidetab-menu">
                                <div class="panel-body tabs-menu-body p-0 border-0">
                                  <div class="tab-content">
                                    <div class="tab-pane active">
                                      <ul class="sidemenu-list">
                                        <li
                                            v-for="child in item.children"
                                            :key="child.label"
                                        >
                                          <router-link
                                              :to="{ name: child.route, params: child.routeParams || {} }"
                                              class="slide-item"
                                              style="font-size: 14px;"
                                          >
                                            {{ child.label }}
                                          </router-link>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </template>
                        </li>
                      </ul>

                        <div class="slide-right" id="slide-right">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191"
                                width="24" height="24" viewBox="0 0 24 24">
                                <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z" />
                            </svg></div>
                    </div>
                </div>
            </div>
            <!--/APP-SIDEBAR-->

            <!--app-content open-->
            <div class="main-content app-content mt-0">
                <div class="side-app">

                    <!-- CONTAINER -->
                    <div class="main-container container-fluid">
                        <router-view/>
                    </div>
                </div>
            </div>
        </div>

<!--        <div class="modal fade" id="country-selector">-->
<!--            <div class="modal-dialog modal-dialog-centered" role="document">-->
<!--                <div class="modal-content country-select-modal">-->
<!--                    <div class="modal-header">-->
<!--                        <h6 class="modal-title">Choose Country</h6><button aria-label="Close" class="btn-close"-->
<!--                            data-bs-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>-->
<!--                    </div>-->
<!--                    <div class="modal-body">-->
<!--                        <ul class="row p-3">-->
<!--                            <li class="col-lg-6 mb-2">-->
<!--                                <a href="javascript:void(0)" class="btn btn-country btn-lg btn-block active">-->
<!--                                    <span class="country-selector"><img alt="" src="/images/flags-img/us_flag.jpg"-->
<!--                                            class="me-3 language"></span>USA-->
<!--                                </a>-->
<!--                            </li>-->
<!--                            <li class="col-lg-6 mb-2">-->
<!--                                <a href="javascript:void(0)" class="btn btn-country btn-lg btn-block">-->
<!--                                    <span class="country-selector"><img alt=""-->
<!--                                        src="/images/flags-img/italy_flag.jpg"-->
<!--                                        class="me-3 language"></span>Italy-->
<!--                                </a>-->
<!--                            </li>-->
<!--                            <li class="col-lg-6 mb-2">-->
<!--                                <a href="javascript:void(0)" class="btn btn-country btn-lg btn-block">-->
<!--                                    <span class="country-selector"><img alt=""-->
<!--                                        src="/images/flags-img/spain_flag.jpg"-->
<!--                                        class="me-3 language"></span>Spain-->
<!--                                </a>-->
<!--                            </li>-->
<!--                            <li class="col-lg-6 mb-2">-->
<!--                                <a href="javascript:void(0)" class="btn btn-country btn-lg btn-block">-->
<!--                                    <span class="country-selector"><img alt=""-->
<!--                                        src="/images/flags-img/india_flag.jpg"-->
<!--                                        class="me-3 language"></span>India-->
<!--                                </a>-->
<!--                            </li>-->
<!--                            <li class="col-lg-6 mb-2">-->
<!--                                <a href="javascript:void(0)" class="btn btn-country btn-lg btn-block">-->
<!--                                    <span class="country-selector"><img alt=""-->
<!--                                        src="/images/flags-img/french_flag.jpg"-->
<!--                                        class="me-3 language"></span>French-->
<!--                                </a>-->
<!--                            </li>-->
<!--                            <li class="col-lg-6 mb-2">-->
<!--                                <a href="javascript:void(0)" class="btn btn-country btn-lg btn-block">-->
<!--                                    <span class="country-selector"><img alt=""-->
<!--                                        src="/images/flags-img/russia_flag.jpg"-->
<!--                                        class="me-3 language"></span>Russia-->
<!--                                </a>-->
<!--                            </li>-->
<!--                            <li class="col-lg-6 mb-2">-->
<!--                                <a href="javascript:void(0)" class="btn btn-country btn-lg btn-block">-->
<!--                                    <span class="country-selector"><img alt=""-->
<!--                                        src="/images/flags-img/germany_flag.jpg"-->
<!--                                        class="me-3 language"></span>Germany-->
<!--                                </a>-->
<!--                            </li>-->
<!--                            <li class="col-lg-6 mb-2">-->
<!--                                <a href="javascript:void(0)" class="btn btn-country btn-lg btn-block">-->
<!--                                    <span class="country-selector"><img alt=""-->
<!--                                        src="/images/flags-img/argentina.jpg"-->
<!--                                        class="me-3 language"></span>Argentina-->
<!--                                </a>-->
<!--                            </li>-->
<!--                            <li class="col-lg-6 mb-2">-->
<!--                                <a href="javascript:void(0)" class="btn btn-country btn-lg btn-block">-->
<!--                                    <span class="country-selector"><img alt="" src="/images/flags-img/malaysia.jpg"-->
<!--                                        class="me-3 language"></span>Malaysia-->
<!--                                </a>-->
<!--                            </li>-->
<!--                            <li class="col-lg-6 mb-2">-->
<!--                                <a href="javascript:void(0)" class="btn btn-country btn-lg btn-block">-->
<!--                                    <span class="country-selector"><img alt="" src="/images/flags-img/turkey.jpg"-->
<!--                                        class="me-3 language"></span>Turkey-->
<!--                                </a>-->
<!--                            </li>-->
<!--                        </ul>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->

      <CountrySelectorModal />

    </div>
    <!-- FOOTER -->
    <footer class="footer">
        <div class="container">
            <div class="row align-items-center flex-row-reverse">
                <div class="col-md-12 col-sm-12 text-center">
                    Copyright © <span id="year">2025</span> <a href="javascript:void(0)">DODO</a>. Tous droits réservés.
                </div>
            </div>
        </div>
    </footer>
    <!-- FOOTER END -->
        <!-- BACK-TO-TOP -->
     <a href="#top" id="back-to-top"><i class="fa fa-angle-up"></i></a>
</body>
</template>

<script>

  import {mapActions, mapGetters, mapMutations} from "vuex";
import {menuItems} from "../../config/menu"
  import * as lang from "vuejs-datepicker/src/locale";
  import PerfectScrollbar from 'perfect-scrollbar'
  import CountrySelectorModal from "../../components/modals/CountrySelectorModal.vue";

export default {
  name: "Home",
  components: {CountrySelectorModal},
  beforeDestroy() {
    document.body.classList.remove(
        'app',
        'sidebar-mini',
        'ltr'
    )
  },
  watch: {
    $route() {
      this.$nextTick(() => {
        const sidebar = document.querySelector('.app-sidebar');
        if (sidebar && sidebar._ps) {
          sidebar._ps.update();
        }
      });
    }
  },
  async mounted() {
    document.body.classList.add(
        'app',
        'sidebar-mini',
        'ltr'
    )



    await this.initTemplateScripts();
    // this.loadScript('/assets/plugins/bootstrap5-typehead/autocomplete.js')
    // this.loadScript('/assets/js/typehead.js')
    // this.loadScript('/assets/plugins/p-scroll/perfect-scrollbar.js')
    // this.loadScript('/assets/plugins/p-scroll/pscroll.js')
    // this.loadScript('/assets/plugins/p-scroll/pscroll-1.js')
    // this.loadScript('/assets/plugins/sidemenu/sidemenu.js')
    // this.loadScript('/assets/plugins/sidebar/sidebar.js')
    // this.loadScript('/assets/js/themeColors.js')
    // this.loadScript('/assets/js/sticky.js')
    // this.loadScript('/assets/js/custom.js')
    // this.loadScript('/assets/js/custom-swicher.js')
    // this.loadScript('/assets/switcher/js/switcher.js')

    this.$store.dispatch('cart/loadCart');
    this.loadNotifications();

    this.$nextTick(() => {
      const sidebar = document.querySelector('.app-sidebar');

      if (sidebar) {
        if (sidebar._ps) {
          sidebar._ps.destroy();
        }

        sidebar._ps = new PerfectScrollbar(sidebar, {
          suppressScrollX: true,
          wheelPropagation: false,
        });
      }
    });


    // this.$nextTick(() => {
    //   const sidebar = document.querySelector('.app-sidebar');
    //   if (sidebar && window.PerfectScrollbar) {
    //     new PerfectScrollbar(sidebar, {
    //       useBothWheelAxes: true,
    //       suppressScrollX: true,
    //       suppressScrollY: false,
    //     });
    //   }
    // });
    //
    // this.$nextTick(() => {
    //     if (window.$ && typeof window.$('.slide').slideUp === 'function') {
    //         // Forcer le script jQuery de Sash à recalculer les menus
    //         $('.side-menu__item').off('click').on('click', function (e) {
    //             let $this = $(this);
    //             let $parent = $this.closest('.slide');
    //             let $submenu = $parent.find('.slide-menu');
    //
    //             if (!$parent.hasClass('is-expanded')) {
    //             $('.slide').removeClass('is-expanded');
    //             $('.slide-menu').slideUp(300);
    //             $parent.addClass('is-expanded');
    //             $submenu.slideDown(300);
    //             } else {
    //             $submenu.slideUp(300);
    //             $parent.removeClass('is-expanded');
    //             }
    //         });
    //     }
    //     if (window.$ && typeof window.$('.sub-slide').slideUp === 'function') {
    //         // Forcer le script jQuery de Sash à recalculer les menus
    //         $('.sub-side-menu__item').off('click').on('click', function (e) {
    //             let $this = $(this);
    //             let $parent = $this.closest('.sub-slide');
    //             let $submenu = $parent.find('.sub-slide-menu');
    //
    //             if (!$parent.hasClass('is-expanded')) {
    //             $('.sub-slide').removeClass('is-expanded');
    //             $('.sub-slide-menu').slideUp(300);
    //             $parent.addClass('is-expanded');
    //             $submenu.slideDown(300);
    //             } else {
    //             $submenu.slideUp(300);
    //             $parent.removeClass('is-expanded');
    //             }
    //         });
    //     }
    // });
  },
  computed: {
    currentLanguageName() {
      const langMap = {
        'fr': 'Français',
        'en': 'English',
      };
      return langMap[this.$i18n.locale] || 'Language';
    },
    ...mapGetters('auth', ['user', 'isAuthenticated']),
    ...mapGetters('cart', ['cartItems', 'cartTotal', 'cartTotalItems']),
    ...mapGetters('notifications', ['allNotifications', 'notificationCount', 'hasNotifications']),
    isCartEmpty() {
      return this.cartItems.length === 0;
    },
    roles() {
      return Array.from(new Set([
        ...(this.user?.roles || []),
        ...(this.user?.clientRoles || [])
      ].map(role => role.toUpperCase())));
    },
    filteredMenu() {
      console.log("dffgf", this.roles)
      const hasAccess = (requiredRoles) =>
          requiredRoles.some(role => this.roles.includes(role));


      const filterItems = (items) =>
          items
              .filter(item => !item.roles || hasAccess(item.roles))
              .map(item => ({
                ...item,
                children: item.children ? filterItems(item.children) : null,
              }))
              .filter(item => !item.children || item.children.length > 0);

      return filterItems(menuItems);
    },

  },
  methods: {
    async loadAdminScripts() {
      await this.loadScript('/assets/plugins/bootstrap5-typehead/autocomplete.js')
      await this.loadScript('/assets/js/typehead.js')
      await this.loadScript('/assets/plugins/p-scroll/perfect-scrollbar.js')
      await this.loadScript('/assets/plugins/p-scroll/pscroll.js')
      await this.loadScript('/assets/plugins/p-scroll/pscroll-1.js')
      await this.loadScript('/assets/plugins/sidemenu/sidemenu.js')
      await this.loadScript('/assets/plugins/sidebar/sidebar.js')
      await this.loadScript('/assets/js/themeColors.js')
      await this.loadScript('/assets/js/sticky.js')
      await this.loadScript('/assets/js/custom.js')
      await this.loadScript('/assets/js/custom-swicher.js')
      await this.loadScript('/assets/switcher/js/switcher.js')

    },
    loadScript(src) {
      return new Promise((resolve, reject) => {
        // Vérifie si le script existe déjà pour éviter les doublons
        if (document.querySelector(`script[src="${src}"]`)) {
          resolve();
          return;
        }
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    },
    async initTemplateScripts() {
      // On attend que Vue ait fini de dessiner le menu (v-for) dans le DOM
      await this.$nextTick();

      try {
        // Chargement Séquentiel : Les dépendances d'abord

        // 1. Plugins de base (Scrollbar, etc)
        await this.loadScript('/assets/plugins/p-scroll/perfect-scrollbar.js');
        // await this.loadScript('/assets/plugins/p-scroll/pscroll.js');
        // await this.loadScript('/assets/plugins/p-scroll/pscroll-1.js');

        // 2. Logique du Menu (C'est lui qui gère le click/expand)
        await this.loadScript('/assets/plugins/sidemenu/sidemenu.js');

        // 3. Gestion de la sidebar (Overlay, toggle)
        await this.loadScript('/assets/plugins/sidebar/sidebar.js');

        // 4. Scripts UI globaux (Sticky header, Theme colors)
        await this.loadScript('/assets/js/sticky.js');
        await this.loadScript('/assets/js/themeColors.js');

        // 5. Custom JS (Lancement général)
        await this.loadScript('/assets/js/custom.js');

        // Hack ultime : Parfois Sash a besoin d'un "resize" pour recalculer la hauteur du menu
        window.dispatchEvent(new Event('resize'));

      } catch (error) {
        console.error("Erreur lors du chargement des scripts du template :", error);
      }
    },
    ...mapActions('auth', ['logout']),
    ...mapMutations('cart', ['updateQuantity', 'removeItem']),
    ...mapActions('notifications', ['loadNotifications','markNotificationAsRead']),
    getNotificationTitle(notif) {
      switch (notif.type) {
        case 'SALE_CONFIRMATION':
          return `Nouvelle vente de ${notif.saleConfirmation?.totalAmount?.toLocaleString('fr-FR') || '0'} FCFA`;
        case 'PURCHASE_CONFIRMATION':
          return `Achat à valider : ${notif.purchaseConfirmation.reference}`;
        case 'PAYMENT_CONFIRMATION':
          return `Paiement reçu pour la commande ${notif.paymentConfirmation.orderReference}`;
        case 'DELIVERY_CONFIRMATION':
          return `Livraison confirmée : ${notif.deliveryConfirmation.deliveryReference}`;
        default:
          return 'Nouvelle notification';
      }
    },
    formatDate(dateStr) {
      return new Date(dateStr).toLocaleString("fr-FR");
    },
    markAsRead(id) {
      this.markNotificationAsRead(id);
    },
  },
};
</script>

<style>
.scrollable-cart {
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
